import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiData } from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import s from './MoneyPromoButton.scss';
const MoneyPromoButton = ({ user , moneyPromo , relevantDeviation  })=>{
    const { t  } = useTranslation();
    let biEvid = null;
    let link = null;
    if (moneyPromo === 'tier') {
        biEvid = BiEventType.VIEW_SUBSCRIPTION_TAB;
        link = Url.userSubscriptionsPath({
            username: user.username
        });
    } else if (moneyPromo === 'adoptable') {
        biEvid = BiEventType.VIEW_ADOPTABLES_TAB;
        link = Url.userShopLink(user.username, USER_PROFILE_SHOP_SUB_PATHS.ADOPTABLES);
    } else if (moneyPromo === 'commission') {
        biEvid = BiEventType.VIEW_COMMISSIONS_TAB;
        link = Url.userShopLink(user.username, USER_PROFILE_SHOP_SUB_PATHS.COMMISSIONS);
    } else if (moneyPromo === 'premium_gallery') {
        biEvid = BiEventType.VIEW_PREMIUM_GALLERIES_TAB;
        link = Url.userShopLink(user.username, USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_FOLDERS);
    }
    if (!link) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(BiLink, {
        className: s['root'],
        href: link,
        biData: relevantDeviation && biEvid ? BiData({
            evid: biEvid,
            typeid: relevantDeviation.typeId,
            itemid: relevantDeviation.deviationId,
            referral_info: ReferralType.ART_STAGE_PROMOTION
        }) : undefined
    }, t(`submissionDetailsHeader.moneyPromo.var.${moneyPromo}.CTA`));
};
MoneyPromoButton.displayName = 'MoneyPromoButton';
export default MoneyPromoButton;
